import React, { useEffect, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap';
import useAuth from '../../hooks/useAuth';
import useUtenti from '../../hooks/useUtenti';
import { useSelector } from 'react-redux';
import useSuperpartner from '../../hooks/useSuperpartner';

const InputUserinfo = ({userData, setIsEditMode, onSaveUserInfo, isUpdateUserFromModal, onHide, printAllUtenti}) => {
    const [formData, setFormData] = useState({});
    const options = ["Sig.", "Sig.ra", "Prof.", "Prof.ssa", "Dott.", "Dott.ssa", "Geom.", "Rag.", "Ing.", "Arch.", "Per.", "Avv.", "Ing.", "Cav."];
    const [selectedGender, setSelectedGender] = useState('');
    const [optionsArray, setOptionsArray] = useState([]);
    const [superpartnerList, setSuperpartnerList] = useState([]);
    const {updateUtente, loadingStateUtenti} = useUtenti();
    const { getAllSuperpartner, loadingStateSuperpartner} = useSuperpartner();
    const userLoggedIn = useSelector(state => state?.user?.userData);

    useEffect(() => {
      setFormData(prev => ({
        ...prev,
        ...userData
      }));
      setOptionsArray(options);
      if (userData.tipo_utente === "partner") {
        fetchSuperpartner();
      }
    }, [userData]);

    const fetchSuperpartner = async () => {
      const response = await getAllSuperpartner();
      setSuperpartnerList(response ?? []);
    };

    const onUpdateUserInfo = async () => {//NEW
      // console.log("formData", formData);
      // console.log("file_documento", formData.file_documento);
      // console.log("file_codicefiscale", formData.file_codicefiscale);
      const res = await updateUtente(formData);
    
      if (res) {
        if (!isUpdateUserFromModal) {
          setIsEditMode(false);
          onSaveUserInfo(formData); // assicurati che il backend restituisca l’utente aggiornato
        } else {
          onHide();
          printAllUtenti();
        }
      }
    };

    const handleFormChange = e => {
      const { name, value } = e.target;
      setFormData(prevState => ({ ...prevState, [name]: value }));
    }

    const handleGenderChange = (e) => {
      const selectedOption = e.target.value;
      setSelectedGender(selectedOption);
      setFormData((prevState) => ({ ...prevState, sesso: selectedOption }));
    };

    const handleTitleChange = (event) => {
      const selectedOption = event.target.value;
      setFormData((prevState) => ({ ...prevState, titolo: selectedOption }));
    };

    const undoChanges = () => {
         if(!isUpdateUserFromModal) {
            setIsEditMode(false)
         } else {
            onHide();
         }
    }

    return (
        <>
           <div className='row'>
              <span className='fs-4 d-block'> <i>Informazioni personali</i> </span>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Titolo</b></span>
                    <select className="form-control" value={formData?.titolo || 'Sig.'} onChange={handleTitleChange}>
                        {optionsArray?.map((option, index) => (
                        <option key={index} value={option}>{option}</option>
                        ))}
                   </select>
               </div>
                  <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Nome</b></span>
                    <input name="nome" value={formData?.nome || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Nome" aria-label="Nome"/>
                  </div>
            </div>

            <div className='row'>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Cognome</b></span>
                    <input name="cognome" value={formData?.cognome || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Cognome" aria-label="Cognome"/>
              </div>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Genere</b></span>
                    <select className="form-control"  name="sesso" value={formData.sesso} onChange={handleGenderChange}>
                    <option value="M">Maschio</option>
                    <option value="F">Femmina</option>
                </select>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Città di nascita</b></span>
                    <input name="luogo_nascita" value={formData.luogo_nascita || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Luogo di nascita" aria-label="Luogo di nascita"/>
              </div>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Provincia di nascita</b></span>
                    <input name="provincia_nascita" value={formData.provincia_nascita || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Provincia di nascita" aria-label="Provincia di nascita"/>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Numero di telefono 1</b></span>
                    <input name="telefono1" value={formData.telefono1 || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Numero di telefono 1" aria-label="Numero di telefono 1"/>
              </div>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Numero di telefono 2</b></span>
                    <input name="telefono2" value={formData.telefono2 || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Numero di telefono 2" aria-label="Numero di telefono 2"/>
              </div>
            </div>

            {(userLoggedIn?.tipo_utente === "admin" || userLoggedIn?.tipo_utente === "course_designer" || userLoggedIn?.tipo_utente === "developer") && userData.tipo_utente === "partner" && (
              <div className='row'>
                <div className='col-sm-12 col-md-6 my-2'>
                  <span className='small text-muted d-block'><b>Superpartner</b></span>
                  {loadingStateSuperpartner.isLoadingSuperpartner ? (
                    <div className="text-center py-3">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Caricamento...</span>
                      </div>
                    </div>
                  ) : (
                    <select 
                      name="id_superpartner" 
                      className="form-control" 
                      value={formData.id_superpartner || ''} 
                      onChange={handleFormChange}
                    >
                      <option value="nessuno">Nessuno</option>
                      {superpartnerList.map(superpartner => (
                        <option 
                          key={superpartner.id_superpartner} 
                          value={superpartner.id_superpartner}
                        >
                          {superpartner.nome}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              </div>
            )}

            <div className='col-sm-12 col-md-6 my-2'>
              <span className='small text-muted d-block'><b>Documento di identità</b></span>

              {userData?.path_documento && (
                <div className="mb-2">
                  <a
                    href={userData.path_documento}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    <i className="bi bi-download me-1"></i>
                    Visualizza documento attuale
                  </a>
                  <div className="small text-muted mt-1">
                    {userData.path_documento.split('/').pop()}
                  </div>
                </div>
              )}

              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                className="form-control"
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, file_documento: e.target.files[0] }))
                }
              />
              {formData?.file_documento && (
                <div className="small text-success mt-1">
                  File selezionato: {formData.file_documento.name}
                </div>
              )}
            </div>

            <div className='col-sm-12 col-md-6 my-2'>
              <span className='small text-muted d-block'><b>Codice Fiscale</b></span>

              {userData?.path_codicefiscale && (
                <div className="mb-2">
                  <a
                    href={userData.path_codicefiscale}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    <i className="bi bi-download me-1"></i>
                    Visualizza documento attuale
                  </a>
                  <div className="small text-muted mt-1">
                    {userData.path_codicefiscale.split('/').pop()}
                  </div>
                </div>
              )}

              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                className="form-control"
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, file_codicefiscale: e.target.files[0] }))
                }
              />
              {formData?.file_codicefiscale && (
                <div className="small text-success mt-1">
                  File selezionato: {formData.file_codicefiscale.name}
                </div>
              )}
            </div>

            {
      userData.tipo_utente === "corsista" && (
            <>
           <div className='row mt-4'>
              <span className='fs-4 d-block'> <i>Dati fatturazione</i> </span>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Nominativo/Ragione sociale</b></span>
                    <input name="fatturazione_nominativo" value={formData.fatturazione_nominativo || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Nominativo/Ragione sociale" aria-label="fatturazione nominativo"/>
              </div>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Partita iva</b></span>
                    <input name="fatturazione_piva" value={formData.fatturazione_piva || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Partita iva/Codice fiscale" aria-label="fatturazione_piva"/>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Indirizzo</b></span>
                    <input name="fatturazione_indirizzo" className="form-control" value={formData.fatturazione_indirizzo || ''} onChange={handleFormChange} type="text" placeholder="Indirizzo" aria-label="Indirizzo"/>
              </div>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>CAP</b></span>
                    <input name="fatturazione_cap" className="form-control" value={formData.fatturazione_cap || ''} onChange={handleFormChange} type="text" placeholder="Cap" aria-label="Cap"/>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Città</b></span>
                    <input name="fatturazione_citta" value={formData.fatturazione_citta || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Città" aria-label="Fatturazione città"/>
              </div>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Provincia</b></span>
                    <input name="fatturazione_provincia" value={formData.fatturazione_provincia || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Provincia" aria-label="Fatturazione Provincia"/>
              </div>
            </div>

           <div className='row mt-4'>
              <span className='fs-4 d-block'><i>Dati spedizione</i> </span>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Nominativo/Ragione sociale</b></span>
                    <input name="spedizione_nominativo" value={formData.spedizione_nominativo || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Nominativo/Ragione sociale" aria-label="spedizione nominativo"/>
              </div>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Indirizzo</b></span>
                    <input name="spedizione_indirizzo" value={formData.spedizione_indirizzo || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Indirizzo" aria-label="spedizione indirizzo"/>
              </div>
            </div>
            <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>CAP</b></span>
                    <input name="spedizione_cap" value={formData.spedizione_cap || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="CAP" aria-label="spedizione cap"/>
              </div>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Città</b></span>
                    <input name="spedizione_citta" value={formData.spedizione_citta || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Città" aria-label="spedizione città"/>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block'><b>Provincia</b></span>
                    <input name="spedizione_provincia" value={formData.spedizione_provincia || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Provincia" aria-label="spedizione provincia"/>
              </div>
            </div>
            </>
      )
     }
          
            <div className='mt-4'>
             { loadingStateUtenti.isLoadingUtentiUpdate ? (
                  <Button variant="primary" disabled className="mx-1">
                  <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                  />
                  Salva modifiche...
                  </Button>
                  ) : (
                  <Button type="button" variant='primary' onClick={onUpdateUserInfo} className="mx-1">
                        Salva modifiche
                  </Button>
                  )}
               <button className='btn btn-secondary mx-1' onClick={undoChanges}>Annulla</button>
            </div>
        </>
      )
}

export default InputUserinfo
